import React from 'react';
import styled from 'styled-components';
import { media } from '~/styles/mixins';
import logger from '~/services/logger';
import {
	featureImages,
	type FeatureImages,
	type FeatureType,
} from '../../assets/imageImports';

const MainImageWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: 40px 0;

	${media.belowLarge`
		padding: 20px 0;
	`}

	img {
		width: 100%;
		max-width: 1330px;
		height: auto;
		object-fit: contain;
	}
`;

interface MainImageProps {
	feature: FeatureType;
	imageName: string;
}

const MainImage: React.FC<MainImageProps> = ({ feature, imageName }) => {
	const images = featureImages[feature as keyof FeatureImages];
	if (!images) {
		return null;
	}

	const imagePath = images[imageName as keyof typeof images];
	if (!imagePath) {
		logger.error(`Image ${imageName} not found for feature ${feature}`);
		return null;
	}

	return (
		<MainImageWrapper>
			<img src={imagePath} alt="Feature demonstration" />
		</MainImageWrapper>
	);
};

export default MainImage;
